import { createContext, useContext, useEffect, useState } from "react";

const PrivacyContext = createContext({ blurred: true, toggle: () => {} });

const STORAGE_KEY = "letfly_surnames_blurred";

export function PrivacyProvider({ children }) {
  const [blurred, setBlurred] = useState(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      return v === null ? true : v === "1";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, blurred ? "1" : "0");
    } catch { /* ignore */ }
  }, [blurred]);

  const toggle = () => setBlurred((b) => !b);
  return (
    <PrivacyContext.Provider value={{ blurred, toggle }}>
      {children}
    </PrivacyContext.Provider>
  );
}

export function usePrivacy() {
  return useContext(PrivacyContext);
}
